<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.accordion-toggle').forEach(button => {
    console.log("click event attached");
    button.addEventListener('click', () => {
      console.log("button clicked");
      const dropdownMenu = button.parentElement.nextElementSibling;
      button.classList.toggle('active');
      if (button.classList.contains('active')) {
        dropdownMenu.style.maxHeight = dropdownMenu.scrollHeight + 'px'; // Expand to the full height
      } else {
        dropdownMenu.style.maxHeight = 0; // Collapse
      }
    });
  });
});

 document.addEventListener("DOMContentLoaded", function() {
  const radiobtn = document.querySelectorAll('input[name="language"]');

    const currentUrl = window.location.href;

    let newUrlMobile = currentUrl
      .replace("/","/")
      .replace("/ar/", "/");

    // Add the selected language code 
     radiobtn.forEach(radio => {
        radio.addEventListener('change', function() {
            if (radio.value === "ar") {
        newUrlMobile = newUrlMobile.replace(window.location.origin, window.location.origin + "/ar");
        } else {
        newUrlMobile = newUrlMobile.replace(window.location.origin, window.location.origin);
        }

        console.log(radio.value, ' + ' ,newUrlMobile);
        // Redirect to new URL
        window.location.href = newUrlMobile;
      });
    });




    const radiobtnnew = document.querySelectorAll('input[name="language_desktop"]'); 

    const currentUrlnew = window.location.href;

    let newUrl = currentUrlnew
      .replace("/","/")
      .replace("/ar/", "/");

    // Add the selected language code
     radiobtnnew.forEach(radio => {
        radio.addEventListener('change', function() {
        if (radio.value === "ar") {
        newUrl = newUrl.replace(window.location.origin, window.location.origin + "/ar");
        } else {
        newUrl = newUrl.replace(window.location.origin, window.location.origin);
        }

        console.log(radio.value, ' + ' ,newUrl);
        // Redirect to new URL
        window.location.href = newUrl;
      });
    });
});